import type { NextRunProps } from './types'

import dayjs from 'dayjs'
import { useReducer } from 'react'
import { useInterval } from 'react-use'

import { humanReadableTime } from './functions'

export function NextRun({ value }: NextRunProps): JSX.Element | null {
  const [, update] = useReducer(x => x * -1, 1)

  useInterval(
    () => {
      update()
    },
    value ? 60 * 1000 : null
  )

  if (!value) {
    return null
  }

  return (
    <div className='text-sm text-gray-400 pt-4'>
      Next schedule will be sent{' '}
      <abbr title={dayjs(value).format('MM/DD/YYYY HH:mm:ss')}>{humanReadableTime(value)}</abbr>
    </div>
  )
}
